import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import Button from "~/components/Button";
import { Container } from "~/components/Container";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import useUtmParams from "~/hooks/useUtmParams";
import Trans from "~/types/translationKeys";
import styles from "./ReferralHero.module.scss";

const ReferralHero: FC = () => {
  const { t } = useTranslation();
  const utmParams = useUtmParams();

  return (
    <section className={styles.hero} id="hero">
      <Container className={styles.container}>
        <div className={classNames(styles.left, "max-w-[610px]")}>
          <Text type="title-2" color={Colors.GREY_600} className={styles.tag}>
            {t(Trans.cx_genie_referral_program)}
          </Text>
          <p className={styles.title}>{t(Trans.cx_genie_referral_title)}</p>
          <Text
            type="body-1"
            color={Colors.GREY_600}
            className={styles.content}
          >
            {t(Trans.cx_genie_referral_description)}
          </Text>
          <div>
            <Link
              type="outline"
              href={{
                pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in`,
                query: { ...utmParams },
              }}
              target="_blank"
            >
              <Button>{t(Trans.get_started_today)}</Button>
            </Link>
          </div>
        </div>
        <div className={styles.right}>
          <Image
            src={"/images/hero_affiliate.png"}
            width={608.58}
            height={621}
            alt="Referral Program"
            style={{ objectFit: "contain" }}
          />
        </div>
      </Container>
    </section>
  );
};

export default ReferralHero;
